import BreadCrumb from "Common/BreadCrumb";
import { HeaderTransferForm } from "../components/HeaderTransferForm";
import { DetailTransferForm } from "../components/DetailTransferForm";
import { useTranslation } from "react-i18next";

export const ViewTransferForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t("transferBetweenWarehouse.titleListPage")}
          pageTitle={t("menu.transferBetweenWarehouses")}
        />
        <div className="card">
          <div className="card-body">
            <HeaderTransferForm />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <DetailTransferForm></DetailTransferForm>
          </div>
        </div>
      </div>
    </>
  );
};
